export default "__VITE_ASSET__Dw5oAW3F__"